/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

const tDeliveryGeofenceSchedule = t.type({
  id: t.union([t.number, t.null, t.undefined]),
  enabled_monday: t.boolean,
  enabled_tuesday: t.boolean,
  enabled_wednesday: t.boolean,
  enabled_thursday: t.boolean,
  enabled_friday: t.boolean,
  enabled_saturday: t.boolean,
  enabled_sunday: t.boolean,
});

export const tDeliveryGeofenceV2 = t.type({
  id: t.number,
  geojson: t.string,
  cart_minimum: t.string,
  fee: t.string,
  last_call_minutes: t.number,
  lead_time_minutes: t.number,
  name: t.union([t.string, t.null]),
  display_windows_by_day: t.boolean,
  interval_minutes: t.union([t.number, t.null]),
  max_lead_time_minutes: t.union([t.number, t.null]),
  min_lead_time_minutes: t.union([t.number, t.null]),
  window_minutes: t.union([t.number, t.null]),
  max_orders_per_window: t.union([t.number, t.null]),
  delivery_geofence_schedule: t.union([
    tDeliveryGeofenceSchedule,
    t.null,
    t.undefined,
  ]),
});

export type DeliveryGeofenceSchedule = t.TypeOf<
  typeof tDeliveryGeofenceSchedule
>;
export type DeliveryGeofenceV2 = t.TypeOf<typeof tDeliveryGeofenceV2>;
